import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  addLimit: 'You can add up to <tag>{{number}}</tag> payment cards.',
  addCard: 'Add',
  noCardsAdded: 'You have no saved cards ',
  addCardsForEasyPay: 'Add a card for easy payment',
  expiresIn: 'Expires In',
  cardNumber: 'Card Number',
  cardNumberPlaceholder: 'Card Number',
  holderName: 'Card Holder Name',
  holderNamePlaceholder: 'Enter Card Holder Name',
  expiryDate: 'Expiry Date',
  cardNumberLengthError: 'Card number must be 16 or 15 digits',
  cardSecurityCodeTypeError: 'CVV must contain only digits',
  invalidExpiryDate: 'Invalid Expiry Date',
  deleteCard: 'Delete Card',
  cancelConfirmation: 'Are you sure you want to delete card?',
  invalidCardNumber: 'Please enter card Number',
  invalidHolderName: 'Invalid Card Holder Name',
  cvv: 'CVV Number',
  cvvPlaceholder: 'CVV',
  invalidCvv: 'Invalid CVV',
});
